import React, { useEffect, useState } from 'react'
import QmModuleStyle from '../styles/qm.module.css';
import profit from '../assets/profit.png';
import UtilizedInvestments from './UtilizedInvestments';
import AvailableInvestments from './AvailableInvestments';
import Button from '../../common/Button'

const MakeDecisions = ({ pOrderActivityHeight, setPOrderActivityHeight, simObj, setSimObj, formatNum, setError, toggleSimulation, setToggleSimulation, isRequestLoading, getMonth, setIsShowPlaceOrder,skipWalkThruPopups, qmPopup, setQmPopup,setIsRequestLoading }) => {
    const [isUtilizedActive, setIsUtilizedActive] = useState(false);
    const [makeInvestmentTop, setMakeInvestmentTop] = useState(0);
    const changeTabs = (e) => {

        // if (document.querySelector(".popup-container ui.stackable.two.column.grid") == null) {
        const target = window.$(e.target).closest('.item.tab-item')[0];
        const parent = target.parentNode;
        let grandparent = parent.parentNode;
        // Remove all current selected tabs
        parent
            .querySelectorAll('[aria-selected="true"]')
            .forEach((t) => {
                t.setAttribute("aria-selected", false);
                t.setAttribute("tabindex", "-1");
                t.style.borderBottom = "none";
                t.style.color = "rgba(0,0,0,.6)";
                t.classList.remove(`${QmModuleStyle["active"]}`);
                t.classList.remove(`active`);
            });

        // Set this tab as selected
        target.setAttribute("aria-selected", true);
        target.removeAttribute("tabindex")
        target.style.borderBottom = "2px solid #B90000"
        target.style.color = "#B90000"
        target.classList.add(`${QmModuleStyle["active"]}`);
        target.classList.add(`active`);

        // Hide all tab panels
        if (grandparent.classList.contains("stackable")) {
            grandparent
                .querySelectorAll('[role="tabpanel"]')
                .forEach((p) => {
                    p.setAttribute("hidden", true);
                    p.classList.remove(`active`);
                });
        }
        else {
            grandparent
                .querySelectorAll(`#panelList>div[role="tabpanel"]`)
                .forEach((p) => {
                    p.setAttribute("hidden", true);
                    p.classList.remove(`active`);
                });
        }
        // Show the selected panel
        let targetId = target.getAttribute("aria-controls");
        if (document.getElementById(targetId) != null) {
            document
                .getElementById(targetId)
                .removeAttribute("hidden");
            document
                .getElementById(targetId).classList.add(`active`)
        }
        setTimeout(() => {
            if (document.getElementById(targetId) != null) {
                document.getElementById(targetId).tabIndex = 0;
                document.getElementById(targetId).focus();
            }
        }, 1000);
        // }
        (target.getAttribute("id") == "tab_2") ? setIsUtilizedActive(true) : setIsUtilizedActive(false);

    }
    const handleInvestmentTabs = () => {
        const tabs = document.getElementsByClassName(`${QmModuleStyle['decision-tabs']}`)[0].querySelectorAll(`[role="tab"]`);
        const tabList = document.getElementsByClassName(`${QmModuleStyle['decision-tabs']}`)[0]

        // Add a click event handler to each tab
        tabs.forEach((tab) => {
            tab.addEventListener("click", (e) => {
                changeTabs(e);
                const tabs = document.getElementsByClassName(`${QmModuleStyle['decision-tabs']}`)[0].querySelectorAll(`[role="tab"]`);
                let activeTab =  window.$(e.target).closest('.item.tab-item')[0];
                  tabs.forEach((tab) => {
                    tab.setAttribute("tabindex", "-1");
                  });
                  setTimeout(() => {
                    activeTab.setAttribute("tabindex", "0");
                    tabFocus = Array.from(tabs).indexOf(activeTab);
                  }, 0)
            });
        });

        // Enable arrow navigation between tabs in the tab list
        let tabFocus = 0;

        tabList.addEventListener("keydown", (e) => {
            // Move right
            const tabs = document.getElementsByClassName(`${QmModuleStyle['decision-tabs']}`)[0].querySelectorAll(`[role="tab"]`);
            if ((e.shiftKey && e.key === 'Tab') || (e.key == "Tab")) {
                let activeTab = document.getElementsByClassName(`${QmModuleStyle['decision-tabs']}`)[0].querySelector(`[role="tab"].active`)
                tabs.forEach((tab) => {
                    tab.setAttribute("tabindex", "-1");
                });
                setTimeout(() => {
                    activeTab.setAttribute("tabindex", "0");
                    tabFocus = Array.from(tabs).indexOf(activeTab);
                }, 100)
            }
            if (e.key === "ArrowRight" || e.key === "ArrowLeft" || e.key === "ArrowUp" || e.key === "ArrowDown" || e.key === 'Home' || e.key === 'End') {
                tabs[tabFocus].setAttribute("tabindex", -1);
                if (e.key === "ArrowRight" || e.key === "ArrowDown") {
                    tabFocus++;
                    // If we're at the end, go to the start
                    if (tabFocus >= tabs.length) {
                        tabFocus = 0;
                    }
                    // Move left
                } else if (e.key === "ArrowLeft" || e.key === "ArrowUp") {
                    tabFocus--;
                    // If we're at the start, move to the end
                    if (tabFocus < 0) {
                        tabFocus = tabs.length - 1;
                    }
                }
                else if (e.key === "Home") {
                    tabFocus = 0;
                }
                else if (e.key === "End") {
                    tabFocus = tabs.length - 1;
                }
                e.preventDefault();
                tabs[tabFocus].setAttribute("tabindex", 0);
                tabs[tabFocus].focus();
            }
        });
        // tabs[0].click();
    }
    useEffect(() => {
        setPOrderActivityHeight(document.getElementsByClassName(`${QmModuleStyle['make-decision-activity']}`)[0].clientHeight)
        console.log(simObj?.laststate)
    }, [simObj?.laststate]);
    useEffect(() => {
        handleInvestmentTabs();
    }, []);

    useEffect(() => {
        const handleResize = () =>{
            if(qmPopup?.makeInvetsment && document.getElementsByClassName("ui pointing label")[0] != null){
                let top = document.getElementsByClassName(`${QmModuleStyle["decision-heading"]}`)[0].clientHeight + document.getElementsByClassName(`${QmModuleStyle["decision-heading"]}`)[0].offsetTop;
                setMakeInvestmentTop(top);
            }
        }
        window.addEventListener('resize', handleResize);
        handleResize();
    },[qmPopup?.makeInvetsment]);
    return (
        <div className={`${QmModuleStyle['make-decisions']}`}>
            <div className={`${QmModuleStyle['decision-heading']} ${(qmPopup?.makeInvetsment) ? `show ${QmModuleStyle['show']}` : ''}`}>
                <img src={profit} alt="" />
                <h3>Make Investment</h3>
            </div>
            {
                qmPopup?.makeInvetsment ? <div className={`ui pointing label ${QmModuleStyle.ui} ${QmModuleStyle.pointing} ${QmModuleStyle.label} ${QmModuleStyle['make-investment-popup']}`} role='dialog' aria-modal="true" aria-label="Make investment popup" tabIndex={-1} style={{top:makeInvestmentTop+"px"}}>
                    <p>Every month the simulation will automatically pause and the menu will open automatically to prompt you to make an investment in quality. If you want to make an investment any other time, click the Make Investment button to open the menu. You can skip investing by clicking Resume Simulation, but be sure there isn't a problem to address!</p>
                    <div className={`${QmModuleStyle.mt10} ${QmModuleStyle.dflex}`}>
                    <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
                    <Button btnName="Next" btnParentClassName={`${QmModuleStyle.ml10}`} btnWidth="80" clickEventHandler={() => {
                        setQmPopup((prevQmPopup) => ({...prevQmPopup, ['makeInvetsment'] : false, ['pauseSimulation'] : true}))
                    }} />
                    </div>
                </div> : ""
            }

            <div className={`${QmModuleStyle['decision-main']}`} id='decisionMain'>
                <div role="tablist" aria-label="Investment tabs" className={`${QmModuleStyle['decision-tabs']}`}>
                    <button
                        className={`item tab-item ui button active ${QmModuleStyle['ui']} ${QmModuleStyle['button']}`}
                        role="tab"
                        aria-selected="true"
                        aria-controls="panel_1"
                        id="tab_1"
                        tabIndex="0"
                        style={{ borderBottom: "2px solid #B90000", color: "#B90000" }}
                    >
                        Available Investments
                    </button>
                    <button
                        className={`item tab-item ui button ${QmModuleStyle['ui']} ${QmModuleStyle['button']}`}
                        role="tab"
                        aria-selected="false"
                        aria-controls={`panel_2`}
                        id="tab_2"
                        tabIndex="-1">
                        Utilized Investments
                    </button>
                </div>
                <div id="panelList" className={`${QmModuleStyle['panel-list']}`}>
                    <div id='panel_1' className={`${QmModuleStyle['_panel_1']}`} role="tabpanel" tabIndex="0" aria-labelledby="tab_1">
                        <AvailableInvestments simObj={simObj} setSimObj={setSimObj} formatNum={formatNum} setError={setError} toggleSimulation={toggleSimulation} setToggleSimulation={setToggleSimulation} isRequestLoading={isRequestLoading} setIsShowPlaceOrder={setIsShowPlaceOrder} setIsRequestLoading={setIsRequestLoading}/>
                    </div>
                    <div id="panel_2" role="tabpanel" className={`${QmModuleStyle['panel-2']}`} tabIndex="0" aria-labelledby="tab_2" hidden>
                        <UtilizedInvestments simObj={simObj} setSimObj={setSimObj} formatNum={formatNum} setError={setError} toggleSimulation={toggleSimulation} setToggleSimulation={setToggleSimulation} isRequestLoading={isRequestLoading} isUtilizedActive={isUtilizedActive} getMonth={getMonth} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MakeDecisions